import { Box } from '@material-ui/core';
import { useParams } from 'react-router-dom';

import { useCreditCardDetails } from '@/components/modules/_shared/hooks/useCreditCard';
import { ErrorSuccessStatusIndicator } from '@/components/modules/AgentDetail/AgentDetails/components/ErrorSuccessStatusIndicator';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { PendingDataType } from '@/config/types';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

export const IberiaClub = () => {
  const { creditCardId } = useParams();

  if (!creditCardId) return null;

  const { onboardingDetails } = useCreditCardDetails({ creditCardId });

  if (!onboardingDetails || !onboardingDetails.iberiaPlus || Array.isArray(onboardingDetails.iberiaPlus)) {
    return (
      <SubSectionWrapper title="IBERIA_CLUB">
        <PendingDataWarning type={PendingDataType.DEFAULT} />
      </SubSectionWrapper>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={18}>
      <SubSectionWrapper title="IBERIA_CLUB">
        <FormGridContainer fieldVariant={FieldVariant.form}>
          <TextFormField
            name={'isPlus'}
            label={'IBERIA_PLUS'}
            value={
              onboardingDetails.iberiaPlus.isPlus ? (
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gridGap={6}>
                  <ErrorSuccessStatusIndicator value={true} />
                  <Text tId={'YES'} />
                </Box>
              ) : (
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gridGap={6}>
                  <ErrorSuccessStatusIndicator value={false} />
                  <Text tId={'NO'} />
                </Box>
              )
            }
          />
          {onboardingDetails.iberiaPlus.iberiaPlusNumber && (
            <TextFormField
              name={'iberiaPlusNumber'}
              label={'IBERIA_CLUB_NUMBER'}
              value={onboardingDetails.iberiaPlus.iberiaPlusNumber}
            />
          )}
        </FormGridContainer>
      </SubSectionWrapper>
    </Box>
  );
};

export const IberiaClubModule = withPermissionsModule(IberiaClub);
